module.exports = __webpack_public_path__ + "images/emoji/microphone.cfb01e88491eb5650470.png";